import { LocaleConfiguration } from 'bold-ui'

export enum AggregatorEnum {
  PERCENTUAL = 'PERCENTUAL',
  CONTAGEM = 'CONTAGEM',
  MEDIA = 'MEDIA',
  MAXIMO = 'MAXIMO',
  MINIMO = 'MINIMO',
}

export type AggregatorLabels = Pick<
  LocaleConfiguration['aggregators'],
  'count' | 'percentage' | 'average' | 'maximum' | 'minimum'
>

export type AggregatorFunction = (values: number[], total?: number) => number

export type Aggregator = {
  id: AggregatorEnum
  label: string
  value: AggregatorFunction | undefined
  keyDependent: boolean
  chain?: Aggregator[]
  suffix?: string
}
